import { BehaviorSubject } from "rxjs";

export interface TimeSeriesDataPoint<T> {
  value: T;
  timestamp: number;
}

export class TimeSeries<T> {
  private dataPointsSubject$ = new BehaviorSubject<TimeSeriesDataPoint<T>[]>(
    []
  );
  numberOfDataPoints: number;
  readonly values$ = this.dataPointsSubject$.asObservable();

  constructor({ numberOfDataPoints }: { numberOfDataPoints: number }) {
    this.numberOfDataPoints = numberOfDataPoints;
  }

  /**
   * Adds a data point
   */
  addDataPoint(dataPoint: TimeSeriesDataPoint<T>) {
    const newPoints = [...this.dataPointsSubject$.getValue(), dataPoint];
    if (newPoints.length > this.numberOfDataPoints) {
      newPoints.shift();
    }
    this.dataPointsSubject$.next(newPoints);
  }

  /**
   * Merge in data points
   */
  mergeDataPoints(dataPoints: TimeSeriesDataPoint<T>[]) {
    const timestampMap = new Map<number, TimeSeriesDataPoint<T>>();
    for (const point of this.dataPointsSubject$.getValue()) {
      timestampMap.set(point.timestamp, point);
    }
    for (const point of dataPoints) {
      timestampMap.set(point.timestamp, point);
    }
    let newPoints = Array.from(timestampMap.values());
    const numOverLimit = Math.max(
      newPoints.length - this.numberOfDataPoints,
      0
    );
    if (numOverLimit > 0) {
      newPoints = newPoints.slice(numOverLimit);
    }
    this.dataPointsSubject$.next(newPoints);
  }
}
